import { PREVIOUS, JSON_FORM, REGULAR_FORM } from '#app/constants/forms.ts'
import {
	type State,
	type Action,
	type JSONState,
	type RegularState,
} from '#types/form/wizard.ts'

export function handlePrevious<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (action.type !== PREVIOUS) {
		return state
	}

	if (state.type === JSON_FORM) {
		const jsonState = state as JSONState<T>
		return {
			...jsonState,
			currentStep: Math.max(0, jsonState.currentStep - 1),
		}
	} else {
		const regularState = state as RegularState<T>
		const { type, ...restOfRegularState } = regularState
		return {
			type: REGULAR_FORM,
			...restOfRegularState,
			currentStep: Math.max(0, regularState.currentStep - 1),
		}
	}
}
